enum EContacts {
  ECARDMESSAGE = "EcardMessage",
  PHOTOMESSAGE = "PhotoMessage",
  VIDEOMESSAGE = "VideoMessage",
  TEXTMESSAGE = "TextMessage",
}

export default EContacts;
